/*global BASE_URL, console, _, Modernizr*/
/*jshint browser:true, jquery:true, undef:true, multistr: true*/
$( document ).ready(function() {
    
    var browserWindow = $( this );

    // [Remove Preloader] ::start
    (function () {
        $( '.listings--preload-panel' ).addClass( 'hidden' );
        $( '.listings--content-panel' ).removeClass( 'hidden' );
    })();
    // [Remove Preloader] ::end

    // Fix issue with bfcache preventing to show the 
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            // Force a reload
            location.reload();
        }
    });

    // [Properties Sidebar] ::start
    (function() {

        var _propertyTypes      = $( '#property_types_chk' ).find( '.checkbox' ),
            _propertyTypeGroups = {
                'for-buyers': [
                    'house-for-sale',
                    'condo-townhouse-for-sale',
                    'land-for-sale',
                    'multi-unit-for-sale',
                    'commercial-buildings-for-sale',
                    'business-for-sale'
                ],
                'for-renters': [
                    'house-for-rent',
                    'condo-townhouse-apartment-for-rent',
                    'commercial-space-for-rent',
                    'land-for-rent'
                ]
            },
            _propertyGroupKeys  = _.keys( _propertyTypeGroups );

        var _hideAllPropertiesOptions = function ()
        {
            // Hide All Property Types
            _propertyTypes.each( function () {
                var _this  = $( this );

                if ( !_this.hasClass('hidden') ) {
                    _this.addClass( 'hidden' );

                    // Reset checked
                    _this.find( 'input[type="checkbox"]' ).prop( 'checked', false );
                }
            });
        };

        var _getPropertyGroup = function ()
        {
            // var firstSelectedProperty = _propertyTypes.find( 'input[type="checkbox"]' ).filter( ':checked' ).eq(0),
            var firstSelectedProperty = _propertyTypes.find( 'input[type="checkbox"]' ).filter( ':checked' ).first(),
                val                   = null,
                seletectedGroupKey    = null;

            if ( firstSelectedProperty.length ) {
                val = firstSelectedProperty.val();

                _.forEach( _propertyGroupKeys, function(propertyGroupKey) {
                    if ( _.includes(_propertyTypeGroups[propertyGroupKey], val) ) {
                        seletectedGroupKey = propertyGroupKey;
                        return seletectedGroupKey;
                    }
                });

            }

            return seletectedGroupKey;
        };

        var _propertyChoices = function( propertyType )
        {

            var selectedPropertyGroups = null;

            if ( _propertyTypeGroups[propertyType] ) {
                selectedPropertyGroups = _propertyTypeGroups[propertyType];
            }

            if ( selectedPropertyGroups === 'all' ||  selectedPropertyGroups === null ) {
                _hideAllPropertiesOptions();
            } else {

                _hideAllPropertiesOptions();

                // Show Property Types based on the group
                _propertyTypes.each( function () {
                    var _this  = $( this ),
                        _input = _this.find( 'input[type="checkbox"]' ),
                        _value = _input.val();

                    if ( _.includes(selectedPropertyGroups, _value) ) {
                        _this.removeClass( 'hidden' );
                    }
                });
            }

        };

        $( '#property_type_options_sel' ).on('changed.bs.select', function () {
            var val = $( this ).selectpicker( 'val' );
            _propertyChoices( val );
        });

        // Get currently selected properties on load
        var _currentPropertyGroup = _getPropertyGroup();
        if ( _currentPropertyGroup !== null ) {
            $( '#property_type_options_sel' ).selectpicker( 'val', _currentPropertyGroup );

            // Hide property checkboxes that does not belong on the selected group
            _.forEach( _propertyGroupKeys, function(propertyGroupKey) {
                if ( _currentPropertyGroup === propertyGroupKey ) {
                    return;
                } else {

                    // Hide checkboxes that does not belong to the current group
                    _propertyTypes.each( function () {
                        var _this  = $( this ),
                            _input = _this.find( 'input[type="checkbox"]' ),
                            _value = _input.val();

                        if ( _.includes(_propertyTypeGroups[propertyGroupKey], _value) ) {
                            _this.addClass( 'hidden' );
                        }
                    });

                }
            });
        } else {
            _hideAllPropertiesOptions();
        }

        // Reset button
        $( '#reset_properties_filter_btn' ).on( 'click', function(e) {
            e.preventDefault();

            $( '#property_type_options_sel' ).selectpicker( 'val', 'all' );
            $( '#property_type_options_sel' ).trigger( 'change' );
            
            $( '#villages_sel' ).selectpicker( 'val', '' );
            $( '#min_price_txt' ).val( '' );
            $( '#max_price_txt' ).val( '' );
            
            $( '#min_beds_sel' ).selectpicker( 'val', '' );
            $( '#min_baths_sel' ).selectpicker( 'val', '' );

        });


        // [Sidebar Filters] ::start
        var _query = [];
        
        var _constructPropertySearchUrl = function ()
        {

            var _minPrice = $( '#min_price_txt' ).val();
            if ( '' !== _minPrice ) {
                _query['min-price'] = parseInt(_minPrice, 10);
            }
            
            var _maxPrice = $( '#max_price_txt' ).val();
            if ( '' !== _maxPrice ) {
                _query['max-price'] = parseInt(_maxPrice, 10);
            }
            
            var _minBeds = $( '#min_beds_sel' ).selectpicker( 'val' );
            if ( '' !== _minBeds ) {
                _query['min-beds'] = parseInt(_minBeds, 10);
            }
            
            var _minBaths = $( '#min_baths_sel' ).selectpicker( 'val' );
            if ( '' !== _minBaths ) {
                _query['min-baths'] = parseInt(_minBaths, 10);
            }
            
            // var _minYear = $( '#min_year_sel' ).selectpicker( 'val' );
            // if ( '' !== _minYear ) {
            //     _query['min-year'] = parseInt(_minYear, 10);
            // }
            //
            // var _maxYear = $( '#max_year_sel' ).selectpicker( 'val' );
            // if ( '' !== _maxYear ) {
            //     _query['max-year'] = parseInt(_maxYear, 10);
            // }
            
            // Selected property types
            var _selectedPropertyTypesEl = _propertyTypes.find( 'input[type="checkbox"]' ).filter( ':checked' ),
                _selectedPropertyTypes = [];

            // _.forEach(_selectedPropertyTypesEl, function (input) {
            //     _selectedPropertyTypes.push( $( input ).val() );
            // });
            _.forEach(_propertyTypes.find( 'input[type="checkbox"]' ), function (input) {
                if ($( input ).is( ':checked' )) {
                    _selectedPropertyTypes.push( $( input ).val() );
                }
            });

            if ( _selectedPropertyTypes.length > 0 ) {
                _query['property-types'] = _selectedPropertyTypes;
            } else {
                delete _query['property-types'];
            }

            var _villages = $( '#villages_sel' ).selectpicker( 'val' );
            if (_.isArray(_villages) && _villages.length > 0) {
                _villages = _.filter(_villages);
            }
            if ( '' !== _villages || (_.isArray(_villages) && _villages.length > 0) ) {
                _query.villages = _villages;
            }
        };

        $( '#property-search-btn' ).on( 'click', function (e) {
            var _this = $( e.currentTarget );

            _this.html('Loading <i class="fa fa-spinner fa-pulse"></i>');
            _this.css('cursor', 'not-allowed');
            _this.closest( 'form' ).find( 'input,select,button').attr( 'disabled', 'disabled' );
            $( '#reset_properties_filter_btn' ).hide();

            e.preventDefault();

            var _newQuery = '',
                _propertyPath;

            _constructPropertySearchUrl();

            _.forIn(_query, function (value, key) {

                if ( key === 'villages' || key === 'areas' ) {
                    key = 'location';
                }

                if (value === null || (_.isArray(value) && value.length === 0)) {
                    return;
                }

                _newQuery += '/' + (key + '-' + value);
            });

            // inherit sort query if does exists in the url
            if (location.pathname.indexOf('order-by-list-price') !== -1) {
                var sortQuery = location.pathname.substring(location.pathname.indexOf('/order-by-list-price'));
                _newQuery = _newQuery + sortQuery;
            }

            _newQuery = _.trimStart(_newQuery, '/,');

            _propertyPath = '/properties/search/' + _newQuery;

            if ( '' === _newQuery ) {
                _propertyPath = '/properties/search';
            }

            window.location = _propertyPath;

        });

        $( '#property-search-btn' ).closest( 'form' ).on('submit', function () {
            $( '#property-search-btn' ).trigger( 'click' );
        });

        var _updatePricesSel = function () 
        {
            var _minPrice = $( '#min_price_txt' ).val(),
                _maxPrice = $( '#max_price_txt' ).val();

            if ( _minPrice === '' ) {
                delete _query['min-price'];
            } else {
                _query['min-price'] = parseInt(_minPrice, 10);
            }
            
            if ( _maxPrice === '' ) {
                delete _query['max-price'];
            } else {
                _query['max-price'] = parseInt(_maxPrice, 10);
            }

            if ( parseInt(_minPrice, 10) > parseInt(_maxPrice, 10) && _minPrice !== '' && _maxPrice !== '' ) {
                delete _query['min-price'];
                _minPrice = '';
                $( '#min_price_txt' ).val( '' );
            }
        };
        
        // var _updateYears = function () 
        // {
        //     var _minYear = $( '#min_year_sel' ).selectpicker( 'val' ),
        //         _maxYear = $( '#max_year_sel' ).selectpicker( 'val' );
        //
        //     if ( _minYear === '' ) {
        //         delete _query['min-year'];
        //     } else {
        //         _query['min-year'] = parseInt(_minYear, 10);
        //     }
        //     
        //     if ( _maxYear === '' ) {
        //         delete _query['max-year'];
        //     } else {
        //         _query['max-year'] = parseInt(_maxYear, 10);
        //     }
        //
        //     if ( parseInt(_minYear, 10) > parseInt(_maxYear, 10) && _minYear !== '' && _maxYear !== '' ) {
        //         delete _query['min-year'];
        //         _minYear = '';
        //         $( '#min_year_sel' ).selectpicker( 'val', '' );
        //     }
        // };

        // min_price_txt
        $( '#min_price_txt' ).on('change', function () {
            _updatePricesSel();
        });
        
        // max_price_txt
        $( '#max_price_txt' ).on('change', function () {
            _updatePricesSel();
        });
        
        // min_beds_sel
        $( '#min_beds_sel' ).on('changed.bs.select', function () {
            var _val          = $( this ).selectpicker('val'),
                _propertyType = $( '#property_types_sel' ).selectpicker('val');

            if ( _val === '' ) {
                delete _query['min-beds'];
            } else {
                _query['min-beds'] = parseInt(_val, 10);
            }
        });
        
        // min_baths_sel
        $( '#min_baths_sel' ).on('changed.bs.select', function () {
            var _val          = $( this ).selectpicker('val'),
                _propertyType = $( '#property_types_sel' ).selectpicker('val');

            if ( _val === '' ) {
                delete _query['min-baths'];
            } else {
                _query['min-baths'] = parseInt(_val, 10);
            }
        });
        
        // // property_types_sel
        // $( '#property_types_sel' ).on('changed.bs.select', function () {
        //     var _val   = $( this ).selectpicker('val');
        //
        //     if ( _val === '' ) {
        //         delete _query['property-types'];
        //     } else {
        //         _query['property-types'] = _val;
        //     }
        //
        //     if ($.inArray('land-for-sale', _val) > -1) {
        //         $( '#min_beds_sel' ).selectpicker( 'val', '' );
        //         $( '#min_baths_sel' ).selectpicker( 'val', '' );
        //     }
        // });
        
        // // min_year_sel
        // $( '#min_year_sel' ).on('changed.bs.select', function () {
        //     _updateYears();
        // });
        //
        // // max_year_sel
        // $( '#max_year_sel' ).on('changed.bs.select', function () {
        //     _updateYears();
        // });
        
        // villages_sel
        $( '#villages_sel' ).on('changed.bs.select', function () {
            var _val   = $( this ).selectpicker( 'val' );

            if ( _val === '' ) {
                delete _query.villages;
            } else {
                _query.villages = _val;
            }
        });
        // [Sidebar Filters] ::end


        // [Filter Properties Panel] ::start
        var filterPropertiesPanelHeading = $( '#filter-properties-panel-heading' );

        filterPropertiesPanelHeading.find( '.panel-title > .link' ).on( 'click', function() {
            $( this ).parents( '.panel-heading' ).toggleClass( 'active' );
        });
        // [Filter Properties Panel] ::end

    })();
    // [Properties Sidebar] ::end


    // [twbs-pagination] ::start
    (function() {

        var paginationTarget = $( '.pagination' );

        if ( paginationTarget.length > 0 ) {

            paginationTarget.each( function () {
                var _this = $( this );

                var paginationOptions = {
                    totalPages: _this.data( 'total-pages' ),
                    visiblePages: _this.data( 'visible-pages' ),
                    startPage: _this.data( 'start-page' ),
                    initiateStartPageClick: false,
                    onPageClick: function (event, page) {
                        // console.log(event, page, _this.data('base-url'));
                        var _newUrl = _this.data( 'base-url' ) + '/' + page;
                        window.location = _newUrl;
                        $( '.listings--preload-panel' ).removeClass( 'hidden' );
                        $( '.listings--content-panel' ).addClass( 'hidden' );
                    },
                    first: '&laquo;',
                    last: '&raquo;'
                };

                // Store original pagination options
                _this.data( '_options', paginationOptions );

                _this.twbsPagination( paginationOptions );
            });

            $( window ).on( 'resize.twbs', _.debounce(function () {
                paginationTarget.each( function () {
                    var _this       = $( this ),
                        _newOptions = {};

                    _newOptions = _this.data( '_options' );

                    // Destroy then re-draw the pagination
                    _this.twbsPagination( 'destroy' );

                    if ( browserWindow.width() < 1200 ) {
                        _newOptions.visiblePages = 3;
                    } else {
                        _newOptions.visiblePages = 5;
                    }

                    _this.twbsPagination( _newOptions );

                });
            }, 300) );

            $( window ).trigger( 'resize.twbs' );

        }

    })();
    // [twbs-pagination] ::end

});
